import { render, staticRenderFns } from "./EmbassyNoticeWrap.vue?vue&type=template&id=5e82ad4a&scoped=true"
import script from "./EmbassyNoticeWrap.vue?vue&type=script&lang=js"
export * from "./EmbassyNoticeWrap.vue?vue&type=script&lang=js"
import style0 from "./EmbassyNoticeWrap.vue?vue&type=style&index=0&id=5e82ad4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e82ad4a",
  null
  
)

export default component.exports